<template>
    <v-btn color="transparent" class=" py-2 mx-4 d-flex align-center" :to="href" style="position: relative">
        <div class="mr-2">{{order}}</div>
        <div style="position: relative">
            {{name}}
            <v-icon v-if="done" color="secondary" class="ml-1" size="16">mdi-check-circle</v-icon>
            <span v-if="optional" class="caption" style="opacity: 0.5">{{$t('Optional')}}</span>
        </div>
    </v-btn>
</template>
<script>
export default {
    props:{
        optional:{
            type: Boolean,
            default: false
        },
        href:{
            type: String
        },
        order: {},
        name:{
            type: String,
            required: true
        },
        done:{
            type: Boolean,
            default: false,
        },
    }
}
</script>
